export default "__VITE_ASSET__385a6698__"